import { VimeoFrame } from "src/utils/fw"
import { getDayRow, modalColor } from "../utils"
import { effect } from "./modals/exploration/dayOne"

export const days = [
    new Date("2024-11-11 00:00:00-05:00"),
    new Date("2024-11-12 08:00:00-05:00"),
    new Date("2024-11-12 19:00:00-05:00")
]

export const Now = (str) => new Date()

const background = () => {
	const now = Now()

    const bgs = [
        [days[0], "https://assets.swoogo.com/uploads/full/4575779-671a99101ce34.png"],
        [days[1], "https://assets.swoogo.com/uploads/full/4575780-671a99102b4ef.png"],
        [days[2], "https://assets.swoogo.com/uploads/full/4575778-671a9910291a7.png"]
    ]


    const bg = getDayRow(bgs, ([d, st]) => d, now)

    return bg[1];
}

const links = [
    {
        top: `13%`,
        left: `9.6%`,
        href: "/1022427132",
        width: `65.2%`,
        height: `7%`,
        label: "Harnessing the Power of Positivity",
        onClick: effect("a604322e-1148-42e9-aae2-42a221e69802")
    },
    {
        top: `21%`,
        left: `9.6%`,
        href: "/1022427334",
        width: `65.2%`,
        height: `7%`,
        label: "Robot Ethics and the Future of Human-Robot Interaction",
        onClick: effect("c90c3e08-037d-4b2f-bd1b-309a88ee33f1")
    },
    ...(Now() >= days[1] ? [
        {
            top: `38%`,
            left: `9.6%`,
            href: "/1022427102",
            width: `65.2%`,
            height: `7%`,
            label: "Embedding a Culture of Innovation into Everyone's DNA",
            onClick: effect("ecc13f8c-3777-472b-9d71-d33299d9e701")
        },
        {
            top: `46%`,
            left: `9.6%`,
            href: "/1022427156",
            width: `65.2%`,
            height: `7%`,
            label: "How to Think Like a Hacker and Help Your Organisation Handle Incidents",
            onClick: effect("7bd4c764-7553-4770-83f8-3eca3dad815b")
        },
    ] : []),
    ...(Now() >= days[2] ? [
        {
            top: `64%`,
            left: `9.6%`,
            href: "/1022427389",
            width: `65.2%`,
            height: `7%`,
            label: "The State of Security: Using pressure to prosper as a security leader",
            onClick: effect("18cd3331-6911-4abd-8e5f-707708118354")
        },
        {
            top: `72%`,
            left: `9.6%`,
            href: "/1022427370",
            width: `65.2%`,
            height: `7%`,
            label: "The Power of Choice",
            onClick: effect("e899c622-05cc-4b58-b7ca-1d9925d42a31")
        }
    ] : [])
].map(it => {
    const params = "?badge=0&autopause=0&quality_selector=1&progress_bar=1&player_id=0&app_id=58479"
    return {
        ...it,
        href: undefined,
        modal: <VimeoFrame wrapperStyle={{ backgroundColor: modalColor }} vidId={it.href.replace(/^\//, "") + params} />
    }
})

export default {
    background: background(), // In case of problems, put BG URL here
    name: "keynotesondemand",
    links: [
        ...links,
		{
			top: `92.6%`,
			left: `42.6%`,
			href: "/atrium",
			width: `14.7%`,
			height: `6%`,
			label: "Back to Atrium"
		}
    ]
}